<template>
  <div class="box-tab">
    <div id="accordion2">
      <div class="panel box-collapse border-color-skin" :class="tabs.tab1 ? 'tab-highlight' : ''">
        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#accordion2" href="#detail2_1">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRES33UC4']['0'] }}
          </h3>
        </div>
        <div id="detail2_1" class="panel-collapse collapse in tab-detail">
          <div class="panel-body">
            <div class="detail-block">
              <div class="row">     
                <div class="col-xs-12 col-ms-6 col-sm-4 col-md-4">
                  <div class="form-group">
                    <label>{{ labels['HRES33UC4']['180'] }}</label>
                    <input type="text" id="coddesc_codinput" name="coddesc_codinput" class="form-control" readonly="readonly" v-model="descCodinput" />
                  </div>
                </div>

                <div class="col-xs-12 col-ms-6 col-sm-4 col-md-4">
                  <div class="form-group">
                    <label>{{ labels['HRES33UC4']['10'] }}</label>
                    <input type="text" id="coddesc_codempid" name="coddesc_codempid" class="form-control" readonly="readonly" v-model="descCodempid" />
                  </div>
                </div>

                <div class="col-xs-12 col-ms-6 col-sm-4 col-md-4">
                  <div class="form-group">
                    <label>{{ labels['HRES33UC4']['20'] }}</label>
                    <input type="text" id="dtereq" name="dtereq" class="form-control" readonly="readonly" :value="setDateOutput(detail.tab1.dtereq)" />
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-6 box-panel-left">
                <form role="form">
                  <div class="text-line-header"><i class="fa fa-bank margin-r-5"></i> {{ labels['HRES33UC4']['50'] }}</div>

                  <div class="form-group">
                    <label>{{ labels['HRES33UC4']['50'] }}</label>
                    <input type="text" id="adrcont1" name="adrcont1" class="form-control" :class="checkHighlight(detail.tab1.flg_adrcont1)" readonly="readonly" v-model="detail.tab1.adrcont1" />
                  </div>

                  <div class="row">                 
                    <div class="col-ms-6 col-sm-6 form-group">
                      <label>{{ labels['HRES33UC4']['60'] }}</label>
                      <input type="text" id="desc_codsubdistr" name="desc_codsubdistr" class="form-control" :class="checkHighlight(detail.tab1.flg_desc_codsubdistr)" readonly="readonly" v-model="detail.tab1.desc_codsubdistr" />
                    </div>

                    <div class="col-ms-6 col-sm-6 form-group">
                      <label>{{ labels['HRES33UC4']['70'] }}</label>
                      <input type="text" id="desc_coddistr" name="desc_coddistr" class="form-control" :class="checkHighlight(detail.tab1.flg_desc_coddistr)" readonly="readonly" v-model="detail.tab1.desc_coddistr" />
                    </div>
                  </div>

                  <div class="row">            
                    <div class="col-ms-6 col-sm-6 form-group">
                      <label>{{ labels['HRES33UC4']['80'] }}</label>
                      <input type="text" id="desc_codprovr" name="desc_codprovr" class="form-control" :class="checkHighlight(detail.tab1.flg_desc_codprovr)" readonly="readonly" v-model="detail.tab1.desc_codprovr" />
                    </div>

                    <div class="col-ms-6 col-sm-6 form-group">
                      <label>{{ labels['HRES33UC4']['90'] }}</label>
                      <input type="text" id="desc_codcntyr" name="desc_codcntyr" class="form-control" :class="checkHighlight(detail.tab1.flg_desc_codcntyr)" readonly="readonly" v-model="detail.tab1.desc_codcntyr" />
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-ms-6 col-sm-6 form-group">
                      <label>{{ labels['HRES33UC4']['100'] }}</label>
                      <input type="text" id="codpostr" name="codpostr" class="form-control" :class="checkHighlight(detail.tab1.flg_codpostr)" readonly="readonly" v-model="detail.tab1.codpostr" />
                    </div>
                  </div>
                </form>
              </div>

              <div class="col-sm-6 box-panel-right">
                <form role="form">
                  <div class="text-line-header"><i class="fa fa-bank margin-r-5"></i> {{ labels['HRES33UC4']['40'] }}</div>

                  <div class="form-group">
                    <label>{{ labels['HRES33UC4']['110'] }}</label>
                    <input type="text" id="adrcont2" name="adrcont2" class="form-control" :class="checkHighlight(detail.tab1.flg_adrcont2)" readonly="readonly" v-model="detail.tab1.adrcont2" />
                  </div>

                  <div class="row">
                    <div class="col-ms-6 col-sm-6 form-group">
                      <label>{{ labels['HRES33UC4']['120'] }}</label>
                      <input type="text" id="desc_codsubdistc" name="desc_codsubdistc" class="form-control" :class="checkHighlight(detail.tab1.flg_desc_codsubdistc)" readonly="readonly" v-model="detail.tab1.desc_codsubdistc" />
                    </div>

                    <div class="col-ms-6 col-sm-6 form-group">
                      <label>{{ labels['HRES33UC4']['130'] }}</label>
                      <input type="text" id="desc_coddistc" name="desc_coddistc" class="form-control" :class="checkHighlight(detail.tab1.flg_desc_coddistc)" readonly="readonly" v-model="detail.tab1.desc_coddistc" />
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-ms-6 col-sm-6 form-group">
                      <label>{{ labels['HRES33UC4']['140'] }}</label>
                      <input type="text" id="desc_codprovc" name="desc_codprovc" class="form-control" :class="checkHighlight(detail.tab1.flg_desc_codprovc)" readonly="readonly" v-model="detail.tab1.desc_codprovc" />
                    </div>

                    <div class="col-ms-6 col-sm-6 form-group">
                      <label>{{ labels['HRES33UC4']['150'] }}</label>
                      <input type="text" id="desc_codcntyc" name="desc_codcntyc" class="form-control" :class="checkHighlight(detail.tab1.flg_desc_codcntyc)" readonly="readonly" v-model="detail.tab1.desc_codcntyc" />
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-ms-6 col-sm-6 form-group">
                      <label>{{ labels['HRES33UC4']['160'] }}</label>
                      <input type="text" id="codpostc" name="codpostc" class="form-control" :class="checkHighlight(detail.tab1.flg_codpostc)" readonly="readonly" v-model="detail.tab1.codpostc" />
                    </div>

                    <div class="col-ms-6 col-sm-6 form-group">
                      <label>{{ labels['HRES33UC4']['170'] }}</label>
                      <input type="text" id="numtelec" name="numtelec" class="form-control" :class="checkHighlight(detail.tab1.flg_numtelec)" readonly="readonly" v-model="detail.tab1.numtelec" />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
 
      <div class="panel box-collapse border-color-skin" :class="tabs.tab2 ? 'tab-highlight' : ''">
        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#accordion2" href="#detail2_2">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRES33UC5']['0'] }}
          </h3>
        </div>
        <div id="detail2_2" class="panel-collapse collapse tab-detail">
          <div class="panel-body">
            <div class="detail-block">
              <div class="row">
                <div class="col-xs-12 col-ms-6 col-sm-4 col-md-4">
                  <div class="form-group">
                    <label>{{ labels['HRES33UC5']['190'] }}</label>
                    <input type="text" id="coddesc_codinput" name="coddesc_codinput" class="form-control" readonly="readonly" v-model="descCodinput2" />
                  </div>
                </div>

                <div class="col-xs-12 col-ms-6 col-sm-4 col-md-4">
                  <div class="form-group">
                    <label>{{ labels['HRES33UC5']['10'] }}</label>
                    <input type="text" id="coddesc_codempid" name="coddesc_codempid" class="form-control" readonly="readonly" v-model="descCodempid2" />
                  </div>
                </div>

                <div class="col-xs-12 col-ms-6 col-sm-4 col-md-4">
                  <div class="form-group">
                    <label>{{ labels['HRES33UC5']['20'] }}</label>
                    <input type="text" id="dtereq" name="dtereq" class="form-control" readonly="readonly" :value="setDateOutput(detail.tab2.dtereq)" />
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-6 box-panel-left">
                <div class="box-panel-center">
                  <form role="form">
                    <div class="text-line-header"><i class="fa fa-credit-card-alt margin-r-5"></i> {{ labels['HRES33UC5']['30'] }}</div>
                    <div class="row">
                      <div class="col-ms-6 col-sm-6 form-group">
                        <label>{{ labels['HRES33UC5']['40'] }}</label>
                        <input type="text" id="numoffid" name="numoffid" class="form-control" :class="checkHighlight(detail.tab2.flg_numoffid)" readonly="readonly" v-model="detail.tab2.numoffid" />
                      </div>

                      <div class="col-ms-6 col-sm-6 form-group">
                        <label>{{ labels['HRES33UC5']['50'] }}</label>
                        <input type="text" id="adrissue" name="adrissue" class="form-control" :class="checkHighlight(detail.tab2.flg_adrissue)" readonly="readonly" v-model="detail.tab2.adrissue" />
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-ms-6 col-sm-6 form-group">
                        <label>{{ labels['HRES33UC5']['60'] }}</label>
                        <input type="text" id="desc_codprovi" name="desc_codprovi" class="form-control" :class="checkHighlight(detail.tab2.flg_desc_codprovi)" readonly="readonly" v-model="detail.tab2.desc_codprovi" />
                      </div>

                      <div class="col-ms-6 col-sm-6 form-group">
                        <label>{{ labels['HRES33UC5']['70'] }}</label>
                        <input type="text" id="dteoffid" name="dteoffid" class="form-control" :class="checkHighlight(detail.tab2.flg_dteoffid)" readonly="readonly" :value="setDateOutput(detail.tab2.dteoffid)" />
                      </div>
                    </div>
                  </form>
                </div>

                <div class="">
                  <form role="form">
                    <div class="text-line-header"><i class="fa fa-credit-card-alt margin-r-5"></i> {{ labels['HRES33UC5']['75'] }}</div>

                    <div class="row">
                      <div class="col-ms-6 col-sm-6 form-group">
                        <label>{{ labels['HRES33UC5']['80'] }}</label>
                        <input type="text" id="numpasid" name="numpasid" class="form-control" :class="checkHighlight(detail.tab2.flg_numpasid)" readonly="readonly" v-model="detail.tab2.numpasid" />
                      </div>

                      <div class="col-ms-6 col-sm-6 form-group">
                        <label>{{ labels['HRES33UC5']['90'] }}</label>
                        <input type="text" id="dtepasid" name="dtepasid" class="form-control" :class="checkHighlight(detail.tab2.flg_dtepasid)" readonly="readonly" :value="setDateOutput(detail.tab2.dtepasid)" />
                      </div>
                    </div>

                    <div class="form-group">
                      <label>{{ labels['HRES33UC5']['100'] }}</label>
                      <input type="text" id="numprmid" name="numprmid" class="form-control" :class="checkHighlight(detail.tab2.flg_numprmid)" readonly="readonly" v-model="detail.tab2.numprmid" />
                    </div>

                    <div class="row">
                      <div class="col-ms-6 col-sm-6 form-group">
                        <label>{{ labels['HRES33UC5']['110'] }}</label>
                        <input type="text" id="dteprmst" name="dteprmst" class="form-control" :class="checkHighlight(detail.tab2.flg_dteprmst)" readonly="readonly" :value="setDateOutput(detail.tab2.dteprmst)" />
                      </div>

                      <div class="col-ms-6 col-sm-6 form-group">
                        <label>{{ labels['HRES33UC5']['120'] }}</label>
                        <input type="text" id="dteprmen" name="dteprmen" class="form-control" :class="checkHighlight(detail.tab2.flg_dteprmen)" readonly="readonly" :value="setDateOutput(detail.tab2.dteprmen)" />
                      </div>
                    </div>
                  </form>
                </div>
              </div>

              <div class="col-sm-6 box-panel-right">
                <div class="box-panel-center">
                  <form role="form">
                    <div class="text-line-header"><i class="fa fa-credit-card-alt margin-r-5"></i> {{ labels['HRES33UC5']['130'] }}</div>

                    <div class="row">
                      <div class="col-ms-6 col-sm-6 form-group">
                        <label>{{ labels['HRES33UC5']['140'] }}</label>
                        <input type="text" id="numlicid" name="numlicid" class="form-control" :class="checkHighlight(detail.tab2.flg_numlicid)" readonly="readonly" v-model="detail.tab2.numlicid" />
                      </div>

                      <div class="col-ms-6 col-sm-6 form-group">
                        <label>{{ labels['HRES33UC5']['150'] }}</label>
                        <input type="text" id="dtelicid" name="dtelicid" class="form-control" :class="checkHighlight(detail.tab2.flg_dtelicid)" readonly="readonly" :value="setDateOutput(detail.tab2.dtelicid)" />
                      </div>
                    </div>
                  </form>
                </div>

                <div class="">
                  <form role="form">
                    <div class="text-line-header"><i class="fa fa-child margin-r-5"></i> {{ labels['HRES33UC5']['160'] }}</div>

                    <div class="row">
                      <div class="col-ms-6 col-sm-6">
                        <div class="form-group">
                          <label>{{ labels['HRES33UC5']['170'] }}</label>
                          <input type="text" id="desc_stamarry" name="desc_stamarry" class="form-control" :class="checkHighlight(detail.tab2.flg_desc_stamarry)" readonly="readonly" v-model="detail.tab2.desc_stamarry" />
                        </div>
                      </div>

                      <div class="col-ms-6 col-sm-6">
                        <div class="form-group">
                          <label>{{ labels['HRES33UC5']['180'] }}</label>
                          <input type="text" id="desc_stamilit" name="desc_stamilit" class="form-control" :class="checkHighlight(detail.tab2.flg_desc_stamilit)" readonly="readonly" v-model="detail.tab2.desc_stamilit" />
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>           
          </div>
        </div>
      </div>

      <div class="panel box-collapse border-color-skin" :class="tabs.tab3 ? 'tab-highlight' : ''">
        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#accordion2" href="#detail2_3">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRES33UC6']['0'] }}
          </h3>
        </div>
        <div id="detail2_3" class="panel-collapse collapse tab-detail">
          <div class="panel-body">
            <div class="detail-block">
              <div class="row">
                <div class="col-xs-12 col-ms-6 col-sm-4 col-md-4">
                  <div class="form-group">
                    <label>{{ labels['HRES33UC6']['230'] }}</label>
                    <input type="text" id="coddesc_codinput" name="coddesc_codinput" class="form-control" readonly="readonly" v-model="descCodinput3" />
                  </div>
                </div>

                <div class="col-xs-12 col-ms-6 col-sm-4 col-md-4">
                  <div class="form-group">
                    <label>{{ labels['HRES33UC6']['10'] }}</label>
                    <input type="text" id="coddesc_codempid" name="coddesc_codempid" class="form-control" readonly="readonly" v-model="descCodempid3" />
                  </div>
                </div>

                <div class="col-xs-12 col-ms-6 col-sm-4 col-md-4">
                  <div class="form-group">
                    <label>{{ labels['HRES33UC6']['20'] }}</label>
                    <input type="text" id="dtereq" name="dtereq" class="form-control" readonly="readonly" :value="setDateOutput(detail.tab3.dtereq)" />
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-6 box-panel-left">
                <div class="box-panel-center">
                  <form role="form">
                    <div class="text-line-header"><i class="fa fa-user-plus margin-r-5"></i> {{ labels['HRES33UC6']['0'] }}</div>

                    <div class="form-group">
                      <label>{{ labels['HRES33UC6']['40'] }}</label>
                      <input type="text" id="namfathr" name="namfathr" class="form-control" :class="checkHighlight(detail.tab3.flg_namfathr)" readonly="readonly" v-model="detail.tab3.namfathr" />
                    </div>

                    <div class="row">
                      <div class="col-sm-6 form-group">
                          <label>{{ labels['HRES33UC6']['50'] }}</label>
                          <input type="text" id="desc_codfnatn" name="desc_codfnatn" class="form-control" :class="checkHighlight(detail.tab3.flg_desc_codfnatn)" readonly="readonly" v-model="detail.tab3.desc_codfnatn" />
                      </div>

                      <div class="col-sm-6 form-group">
                          <label>{{ labels['HRES33UC6']['60'] }}</label>
                          <input type="text" id="desc_codfrelg" name="desc_codfrelg" class="form-control" :class="checkHighlight(detail.tab3.flg_desc_codfrelg)" readonly="readonly" v-model="detail.tab3.desc_codfrelg" />
                      </div>
                    </div>

                    <div class="form-group">
                      <label>{{ labels['HRES33UC6']['70'] }}</label>
                      <input type="text" id="desc_codfoccu" name="desc_codfoccu" class="form-control" :class="checkHighlight(detail.tab3.flg_desc_codfoccu)" readonly="readonly" v-model="detail.tab3.desc_codfoccu" />
                    </div>

                    <div class="form-group">
                      <label>{{ labels['HRES33UC6']['80'] }}</label>
                      <input type="text" id="numofidf" name="numofidf" class="form-control" :class="checkHighlight(detail.tab3.flg_numofidf)" readonly="readonly" v-model="detail.tab3.numofidf" />
                    </div>
                  </form>
                </div>

                <div class="">
                  <form role="form">
                    <div class="text-line-header"><i class="fa fa-user-plus margin-r-5"></i> {{ labels['HRES33UC6']['30'] }}</div>

                    <div class="form-group">
                      <label>{{ labels['HRES33UC6']['100'] }}</label>
                      <input type="text" id="nammothr" name="nammothr" class="form-control" :class="checkHighlight(detail.tab3.flg_nammothr)" readonly="readonly" v-model="detail.tab3.nammothr" />
                    </div>

                    <div class="row">
                      <div class="col-sm-6 form-group">
                        <label>{{ labels['HRES33UC6']['110'] }}</label>
                        <input type="text" id="desc_codmnatn" name="desc_codmnatn" class="form-control" :class="checkHighlight(detail.tab3.flg_desc_codmnatn)" readonly="readonly" v-model="detail.tab3.desc_codmnatn" />
                      </div>

                      <div class="col-sm-6 form-group">
                        <label>{{ labels['HRES33UC6']['120'] }}</label>
                        <input type="text" id="desc_codmrelg" name="desc_codmrelg" class="form-control" :class="checkHighlight(detail.tab3.flg_desc_codmrelg)" readonly="readonly" v-model="detail.tab3.desc_codmrelg" />
                      </div>
                    </div>

                    <div class="form-group">
                      <label>{{ labels['HRES33UC6']['130'] }}</label>
                      <input type="text" id="desc_codmoccu" name="desc_codmoccu" class="form-control" :class="checkHighlight(detail.tab3.flg_desc_codmoccu)" readonly="readonly" v-model="detail.tab3.desc_codmoccu" />
                    </div>

                    <div class="form-group">
                      <label>{{ labels['HRES33UC6']['140'] }}</label>
                      <input type="text" id="numofidm" name="numofidm" class="form-control" :class="checkHighlight(detail.tab3.flg_numofidm)" readonly="readonly" v-model="detail.tab3.numofidm" />
                    </div>
                  </form>
                </div>
              </div>
              <div class="col-sm-6 box-panel-right">
                <form role="form">
                  <div class="text-line-header"><i class="fa fa-user-plus margin-r-5"></i> {{ labels['HRES33UC6']['150'] }}</div>

                  <div class="form-group">
                    <label>{{ labels['HRES33UC6']['160'] }}</label>
                    <input type="text" id="namcont" name="namcont" class="form-control" :class="checkHighlight(detail.tab3.flg_namcont)" readonly="readonly" v-model="detail.tab3.namcont" />
                  </div>

                  <div class="form-group">
                    <label>{{ labels['HRES33UC6']['170'] }}</label>
                    <textarea id="adrcont1" name="adrcont1" class="form-control" :class="checkHighlight(detail.tab3.flg_adrcont1)" maxlength="600" readonly="readonly">{{ detail.tab3.adrcont1}}</textarea>
                  </div>

                  <div class="row">
                    <div class="col-lg-3 form-group">
                      <label>{{ labels['HRES33UC6']['180'] }}</label>
                      <input type="text" id="codpost" name="codpost" class="form-control" :class="checkHighlight(detail.tab3.flg_codpost)" readonly="readonly" v-model="detail.tab3.codpost" />
                    </div>

                    <div class="col-lg-9 form-group">
                      <label>{{ labels['HRES33UC6']['190'] }}</label>
                      <input type="text" id="numtele" name="numtele" class="form-control" :class="checkHighlight(detail.tab3.flg_numtele)" readonly="readonly" v-model="detail.tab3.numtele" />
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-sm-6 form-group">
                      <label>{{ labels['HRES33UC6']['200'] }}</label>
                      <input type="text" id="numfax" name="numfax" class="form-control" :class="checkHighlight(detail.tab3.flg_numfax)" readonly="readonly" v-model="detail.tab3.numfax" />
                    </div>

                    <div class="col-sm-6 form-group">
                      <label>{{ labels['HRES33UC6']['210'] }}</label>
                      <input type="text" id="email" name="email" class="form-control" :class="checkHighlight(detail.tab3.flg_email)" readonly="readonly" v-model="detail.tab3.email" />
                    </div>
                  </div>

                  <div class="form-group">
                    <label>{{ labels['HRES33UC6']['220'] }}</label>
                    <input type="text" id="desrelat" name="desrelat" class="form-control" :class="checkHighlight(detail.tab3.flg_desrelat)" readonly="readonly" v-model="detail.tab3.desrelat" />
                  </div>
                </form>
              </div>

            </div>
          </div>
        </div>
      </div>

      <div class="panel box-collapse border-color-skin" :class="tabs.tab4 ? 'tab-highlight' : ''">
        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#accordion2" href="#detail2_4">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRES33UC7']['0'] }}
          </h3>
        </div>
        <div id="detail2_4" class="panel-collapse collapse tab-detail">
          <div class="panel-body">
            <div class="detail-block">
              <div class="row">      
                <div class="col-xs-12 col-ms-6 col-sm-4 col-md-4">
                  <div class="form-group">
                    <label>{{ labels['HRES33UC7']['150'] }}</label>
                    <input type="text" id="coddesc_codinput" name="coddesc_codinput" class="form-control" readonly="readonly" v-model="descCodinput" />
                  </div>
                </div>

                <div class="col-xs-12 col-ms-6 col-sm-4 col-md-4">
                  <div class="form-group">
                    <label>{{ labels['HRES33UC7']['10'] }}</label>
                    <input type="text" id="coddesc_codempid" name="coddesc_codempid" class="form-control" readonly="readonly" v-model="descCodempid" />
                  </div>
                </div>

                <div class="col-xs-12 col-ms-6 col-sm-4 col-md-4">
                  <div class="form-group">
                    <label>{{ labels['HRES33UC7']['20'] }}</label>
                    <input type="text" id="dtereq" name="dtereq" class="form-control" readonly="readonly" :value="setDateOutput(detail.tab4.dtereq)" />
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-6 box-panel-left">
                <form role="form">
                  <div class="text-line-header"><i class="fa fa-user-plus margin-r-5"></i> {{ labels['HRES33UC7']['30'] }}</div>

                  <div class="form-group">
                    <label>{{ labels['HRES33UC7']['51'] }}</label>
                    <input type="text" id="namspous" name="namspous" class="form-control" :class="checkHighlight(detail.tab4.flg_namspous)" readonly="readonly" v-model="detail.tab4.namspous" />
                  </div>

                  <div class="form-group">
                    <label>{{ labels['HRES33UC7']['60'] }}</label>
                    <input type="text" id="numoffid" name="numoffid" class="form-control" :class="checkHighlight(detail.tab4.flg_numoffid)" readonly="readonly" v-model="detail.tab4.numoffid" />
                  </div>

                  <div class="row">
                    <div class="col-md-6 form-group">
                        <label>{{ labels['HRES33UC7']['70'] }}</label>
                        <input type="text" id="dtespbd" name="dtespbd" class="form-control" :class="checkHighlight(detail.tab4.flg_dtespbd)" readonly="readonly" :value="setDateOutput(detail.tab4.dtespbd)" />
                    </div>

                    <div class="col-md-6 form-group">
                        <label>{{ labels['HRES33UC7']['80'] }}</label>
                        <input type="text" id="desc_codspocc" name="desc_codspocc" class="form-control" :class="checkHighlight(detail.tab4.flg_desc_codspocc)" readonly="readonly" v-model="detail.tab4.desc_codspocc" />
                    </div>
                  </div>

                  <div class="form-group">
                    <label>{{ labels['HRES33UC7']['90'] }}</label>
                    <textarea id="desnoffi" name="desnoffi" class="form-control" :class="checkHighlight(detail.tab4.flg_desnoffi)" maxlength="600" readonly="readonly">{{ detail.tab4.desnoffi }}
                    </textarea>
                  </div>
                </form>
              </div>

              <div class="col-sm-6 box-panel-right">
                <form role="form">
                  <div class="text-line-header"><i class="fa fa-file-text-o margin-r-5"></i> {{ labels['HRES33UC7']['40'] }}</div>

                  <div class="form-group">
                    <label>{{ labels['HRES33UC7']['100'] }}</label>
                    <input type="text" id="dtemarry" name="dtemarry" class="form-control" :class="checkHighlight(detail.tab4.flg_dtemarry)" readonly="readonly" :value="setDateOutput(detail.tab4.dtemarry)" />
                  </div>

                  <div class="form-group">
                    <label>{{ labels['HRES33UC7']['110'] }}</label>
                    <input type="text" id="desplreg" name="desplreg" class="form-control" :class="checkHighlight(detail.tab4.flg_desplreg)" readonly="readonly" v-model="detail.tab4.desplreg" />
                  </div>

                  <div class="row">
                    <div class="col-md-6 form-group">
                        <label>{{ labels['HRES33UC7']['120'] }}</label>
                        <input type="text" id="desc_codsppro" name="desc_codsppro" class="form-control" :class="checkHighlight(detail.tab4.flg_desc_codsppro)" readonly="readonly" v-model="detail.tab4.desc_codsppro" />
                    </div>

                    <div class="col-md-6 form-group">
                        <label>{{ labels['HRES33UC7']['130'] }}</label>
                        <input type="text" id="desc_codspcty" name="desc_codspcty" class="form-control" :class="checkHighlight(detail.tab4.flg_desc_codspcty)" readonly="readonly" v-model="detail.tab4.desc_codspcty" />
                    </div>
                  </div>

                  <div class="form-group">
                    <label>{{ labels['HRES33UC7']['140'] }}</label>
                    <textarea id="desnote" name="desnote" class="form-control" :class="checkHighlight(detail.tab4.flg_desnote)" maxlength="600" readonly="readonly">{{ detail.tab4.desnote }}
                    </textarea>
                  </div>
                </form>
              </div>
            </div>   
          </div>
        </div>
      </div>

      <div class="panel box-collapse border-color-skin" :class="tabs.tab5 ? 'tab-highlight' : ''">
        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#accordion2" href="#detail2_5">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRES33UC8']['0'] }}
          </h3>
        </div>
        <div id="detail2_5" class="panel-collapse collapse tab-detail">
          <div class="panel-body">
            <div class="detail-block">
              <div class="row">
                <div class="col-xs-12 col-ms-6 col-sm-4 col-md-4">
                  <div class="form-group">
                    <label>{{ labels['HRES33UC8']['90'] }}</label>
                    <input type="text" id="coddesc_codinput" name="coddesc_codinput" class="form-control" :class="checkHighlight(detail.tab1.flg_adrcont1)" readonly="readonly" v-model="descCodinput" />
                  </div>
                </div>

                <div class="col-xs-12 col-ms-6 col-sm-4 col-md-4">
                  <div class="form-group">
                    <label>{{ labels['HRES33UC8']['10'] }}</label>
                    <input type="text" id="coddesc_codempid" name="coddesc_codempid" class="form-control" :class="checkHighlight(detail.tab1.flg_adrcont1)" readonly="readonly" v-model="descCodempid" />
                  </div>
                </div>

                <div class="col-xs-12 col-ms-6 col-sm-4 col-md-4">
                  <div class="form-group">
                    <label>{{ labels['HRES33UC8']['20'] }}</label>
                    <input type="text" id="dtereq" name="dtereq" class="form-control" :class="checkHighlight(detail.tab1.flg_adrcont1)" readonly="readonly" :value="setDateOutput(detail.tab5.dtereq)" />
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-6 box-panel-left">
                <form role="form">
                  <div class="text-line-header"><i class="fa fa-bank margin-r-5"></i> {{ labels['HRES33UC15']['40'] }} 1</div>

                  <div class="row">
                    <div class="col-lg-6 form-group">
                      <label>{{ labels['HRES33UC8']['30'] }}</label>
                      <input type="text" id="desc_codbank" name="desc_codbank" class="form-control" :class="checkHighlight(detail.tab5.flg_desc_codbank)" readonly="readonly" v-model="detail.tab5.desc_codbank" />
                    </div>

                    <div class="col-lg-6 form-group">
                      <label>{{ labels['HRES33UC8']['40'] }}</label>
                      <input type="text" id="numbank" name="numbank" class="form-control" :class="checkHighlight(detail.tab5.flg_numbank)" readonly="readonly" v-model="detail.tab5.numbank" />
                    </div>
                  </div>

                  <div class="form-group">
                    <label>{{ labels['HRES33UC8']['50'] }}</label>
                    <input type="text" id="amtbank" name="amtbank" class="form-control" :class="checkHighlight(detail.tab5.flg_amtbank)" readonly="readonly" v-model="detail.tab5.amtbank" />
                  </div>
                </form>
              </div>

              <div class="col-sm-6 box-panel-right">
                <form role="form">
                  <div class="text-line-header"><i class="fa fa-bank margin-r-5"></i> {{ labels['HRES33UC15']['40'] }} 2</div>

                  <div class="row">
                    <div class="col-lg-6 form-group">
                      <label>{{ labels['HRES33UC8']['60'] }}</label>
                      <input type="text" id="desc_codbank2" name="desc_codbank2" class="form-control" :class="checkHighlight(detail.tab5.flg_desc_codbank2)" readonly="readonly" v-model="detail.tab5.desc_codbank2" />
                    </div>

                    <div class="col-lg-6 form-group">
                      <label>{{ labels['HRES33UC8']['70'] }}</label>
                      <input type="text" id="numbank2" name="numbank2" class="form-control" :class="checkHighlight(detail.tab5.flg_numbank2)" readonly="readonly" v-model="detail.tab5.numbank2" />
                    </div>
                  </div>
                </form>
              </div>
            </div>     
          </div>
        </div>
      </div>

      <div class="panel box-collapse border-color-skin" :class="tabs.tab6 ? 'tab-highlight' : ''">
        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#accordion2" href="#detail2_6">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRES33UC9']['0'] }}
          </h3>
        </div>
        <div id="detail2_6" class="panel-collapse collapse tab-detail">
          <div class="panel-body">
            <div class="detail-block">
              <div class="row">
                <div class="col-xs-12 col-ms-6 col-sm-4 col-md-4">
                  <div class="form-group">
                    <label>{{ labels['HRES33UC9']['190'] }}</label>
                    <input type="text" id="coddesc_codinput" name="coddesc_codinput" class="form-control" readonly="readonly" v-model="descCodinput" />
                  </div>
                </div>

                <div class="col-xs-12 col-ms-6 col-sm-4 col-md-4">
                  <div class="form-group">
                    <label>{{ labels['HRES33UC9']['10'] }}</label>
                    <input type="text" id="coddesc_codempid" name="coddesc_codempid" class="form-control" readonly="readonly" v-model="descCodempid" />
                  </div>
                </div>

                <div class="col-xs-12 col-ms-6 col-sm-4 col-md-4">
                  <div class="form-group">
                    <label>{{ labels['HRES33UC9']['20'] }}</label>
                    <input type="text" id="dtereq" name="dtereq" class="form-control" readonly="readonly" :value="setDateOutput(detail.tab6.detail.dtereq)" />
                  </div>
                </div>
              </div>
            </div>

            <div class="detail-block">
              <div class="row">
                <div class="col-xs-12 col-ms-6 col-sm-6">
                  <div class="form-group">
                    <label>{{ labels['HRES33UC9']['150'] }}</label>
                    <div class="input-group">
                      <input type="text" class="form-control" :class="checkHighlight(detail.tab6.flg_qtychedu)" id="qtychedu" name="qtychedu" v-model="detail.tab6.detail.qtychedu" />
                      <div class="input-group-addon input-group-addon-cust">{{ labels['HRES33UC9']['160'] }}</div>
                    </div>
                  </div>
                </div>

                <div class="col-xs-12 col-ms-6 col-sm-6">
                  <div class="form-group">
                    <label>{{ labels['HRES33UC9']['170'] }}</label>
                    <div class="input-group">
                      <input type="text" class="form-control" :class="checkHighlight(detail.tab6.flg_qtychned)" id="qtychned" name="qtychned" v-model="detail.tab6.detail.qtychned" />
                      <div class="input-group-addon input-group-addon-cust">{{ labels['HRES33UC9']['180'] }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <hrms-table :columns="tab2Tab6Table" :data="detail.tab6.table" :rowClassCondition="rowClassCondition" />
              
          </div>
        </div>
      </div>

      <div class="panel box-collapse border-color-skin" :class="tabs.tab7 ? 'tab-highlight' : ''">
        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#accordion2" href="#detail2_7">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRES33UC15']['0'] }}
          </h3>
        </div>
        <div id="detail2_7" class="panel-collapse collapse tab-detail">
          <div class="panel-body">
            <div class="detail-block">
              <div class="row">
                <div class="col-xs-12 col-ms-6 col-sm-4 col-md-4">
                  <div class="form-group">
                    <label>{{ labels['HRES33UC15']['90'] }}</label>
                    <input type="text" id="coddesc_codinput" name="coddesc_codinput" class="form-control" readonly="readonly" v-model="descCodinput" />
                  </div>
                </div>

                <div class="col-xs-12 col-ms-6 col-sm-4 col-md-4">
                  <div class="form-group">
                    <label>{{ labels['HRES33UC15']['10'] }}</label>
                    <input type="text" id="coddesc_codempid" name="coddesc_codempid" class="form-control" readonly="readonly" v-model="descCodempid" />
                  </div>
                </div>

                <div class="col-xs-12 col-ms-6 col-sm-4 col-md-4">
                  <div class="form-group">
                    <label>{{ labels['HRES33UC15']['20'] }}</label>
                    <input type="text" id="dtereq" name="dtereq" class="form-control" readonly="readonly" :value="setDateOutput(detail.tab7.detail.dtereq)" />
                  </div>
                </div>
              </div>
            </div>

            <div class="detail-header">{{ labels['HRES33UC15']['30'] }}</div>

            <hrms-table :columns="tab2Tab7Table" :data="detail.tab7.table" :rowClassCondition="rowClassCondition" />
 
          </div>
        </div>
      </div>
    </div>

    <div class="box-footer">  
        <button type="button" class="btn bg-dark-gray" @click="toggle('index')" value="Back"><i class="fa fa-chevron-circle-left"></i>{{ buttonLabels['back'] }}</button>
    </div>

  </div>
</template>

<script>
import assetsUtils from 'assets/js/utils'
export default {
  data () {
    return {
      tabs: {
        tab1: 0,
        tab2: 0,
        tab3: 0,
        tab4: 0,
        tab5: 0,
        tab6: 0,
        tab7: 0
      }
    }
  },
  name: 'hres33u-detail2',
  props: [ 'labels', 'detail', 'toggle', 'data', 'nowLang', 'tab2Tab6Table', 'tab2Tab7Table', 'buttonLabels' ],
  computed: {
    descCodinput () {
      return this.detail.tab1.codinput + ' - ' + this.detail.tab1.desc_codinput
    },
    descCodempid () {
      return this.detail.tab1.codempid + ' - ' + this.detail.tab1.desc_codempid
    },
    descCodinput2 () {
      return this.detail.tab2.codinput + ' - ' + this.detail.tab2.desc_codinput
    },
    descCodempid2 () {
      return this.detail.tab2.codempid + ' - ' + this.detail.tab2.desc_codempid
    },
    descCodinput3 () {
      return this.detail.tab3.codinput + ' - ' + this.detail.tab3.desc_codinput
    },
    descCodempid3 () {
      return this.detail.tab3.codempid + ' - ' + this.detail.tab3.desc_codempid
    },
    descCodinput4 () {
      return this.detail.tab4.codinput + ' - ' + this.detail.tab4.desc_codinput
    },
    descCodempid4 () {
      return this.detail.tab4.codempid + ' - ' + this.detail.tab4.desc_codempid
    },
    descCodinput5 () {
      return this.detail.tab5.codinput + ' - ' + this.detail.tab5.desc_codinput
    },
    descCodempid5 () {
      return this.detail.tab5.codempid + ' - ' + this.detail.tab5.desc_codempid
    },
    descCodinput6 () {
      return this.detail.tab6.detail.codinput + ' - ' + this.detail.tab6.detail.desc_codinput
    },
    descCodempid6 () {
      return this.detail.tab6.detail.codempid + ' - ' + this.detail.tab6.detail.desc_codempid
    },
    descCodinput7 () {
      return this.detail.tab7.detail.codinput + ' - ' + this.detail.tab7.detail.desc_codinput
    },
    descCodempid7 () {
      return this.detail.tab7.detail.codempid + ' - ' + this.detail.tab7.detail.desc_codempid
    }
  },
  watch: {
    detail () {
      let tab1 = [
        this.detail.tab1.flg_adrcont1,
        this.detail.tab1.flg_desc_codsubdistr,
        this.detail.tab1.flg_desc_coddistr,
        this.detail.tab1.flg_desc_codprovr,
        this.detail.tab1.flg_desc_codcntyr,
        this.detail.tab1.flg_codpostr,
        this.detail.tab1.flg_adrcont2,
        this.detail.tab1.flg_desc_codsubdistc,
        this.detail.tab1.flg_desc_coddistc,
        this.detail.tab1.flg_desc_codprovc,
        this.detail.tab1.flg_desc_codcntyc,
        this.detail.tab1.flg_codpostc,
        this.detail.tab1.flg_numtelec
      ]
      this.tabs.tab1 = this.checkTabHighlight(tab1)
      let tab2 = [
        this.detail.tab2.flg_numoffid,
        this.detail.tab2.flg_adrissue,
        this.detail.tab2.flg_desc_codprovi,
        this.detail.tab2.flg_dteoffid,
        this.detail.tab2.flg_numpasid,
        this.detail.tab2.flg_dtepasid,
        this.detail.tab2.flg_numprmid,
        this.detail.tab2.flg_dteprmst,
        this.detail.tab2.flg_dteprmen,
        this.detail.tab2.flg_numlicid,
        this.detail.tab2.flg_dtelicid,
        this.detail.tab2.flg_desc_stamarry,
        this.detail.tab2.flg_desc_stamilit
      ]
      this.tabs.tab2 = this.checkTabHighlight(tab2)
      let tab3 = [
        this.detail.tab3.flg_namfathr,
        this.detail.tab3.flg_desc_codfnatn,
        this.detail.tab3.flg_desc_codfrelg,
        this.detail.tab3.flg_desc_codfoccu,
        this.detail.tab3.flg_numofidf,
        this.detail.tab3.flg_nammothr,
        this.detail.tab3.flg_desc_codmnatn,
        this.detail.tab3.flg_desc_codmrelg,
        this.detail.tab3.flg_desc_codmoccu,
        this.detail.tab3.flg_numofidm,
        this.detail.tab3.flg_namcont,
        this.detail.tab3.flg_adrcont1,
        this.detail.tab3.flg_codpost,
        this.detail.tab3.flg_numtele,
        this.detail.tab3.flg_numfax,
        this.detail.tab3.flg_email,
        this.detail.tab3.flg_desrelat
      ]
      this.tabs.tab3 = this.checkTabHighlight(tab3)
      let tab4 = [
        this.detail.tab4.flg_namspous,
        this.detail.tab4.flg_numoffid,
        this.detail.tab4.flg_dtespbd,
        this.detail.tab4.flg_desc_codspocc,
        this.detail.tab4.flg_desnoffi,
        this.detail.tab4.flg_dtemarry,
        this.detail.tab4.flg_desplreg,
        this.detail.tab4.flg_desc_codsppro,
        this.detail.tab4.flg_desc_codspcty,
        this.detail.tab4.flg_desnote
      ]
      this.tabs.tab4 = this.checkTabHighlight(tab4)
      let tab5 = [
        this.detail.tab1.flg_adrcont1,
        this.detail.tab1.flg_adrcont1,
        this.detail.tab1.flg_adrcont1,
        this.detail.tab5.flg_desc_codbank,
        this.detail.tab5.flg_numbank,
        this.detail.tab5.flg_amtbank,
        this.detail.tab5.flg_desc_codbank2,
        this.detail.tab5.flg_numbank2
      ]
      this.tabs.tab5 = this.checkTabHighlight(tab5)
      let tab6 = [
        this.detail.tab6.flg_qtychedu,
        this.detail.tab6.flg_qtychned
      ]
      this.tabs.tab6 = this.checkTabHighlight(tab6)
      if (!this.tabs.tab6) {
        this.tabs.tab6 = this.checkTabTableHighlight(this.detail.tab6.table.rows)
      }
      let tab7 = [
      ]
      this.tabs.tab7 = this.checkTabHighlight(tab7)
      if (!this.tabs.tab7) {
        this.tabs.tab7 = this.checkTabTableHighlight(this.detail.tab7.table.rows)
      }
    }
  },
  methods: {
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    },
    checkHighlight (flg) {
      return flg === 'Y' ? 'input-highlight' : ''
    },
    checkTabHighlight (values) {
      let result = values.filter((value) => {
        return value === 'Y'
      })
      return result.length > 0
    },
    checkTabTableHighlight (values) {
      let result = values.filter((value) => {
        return value.flg_status !== undefined && value.flg_status !== 'N'
      })
      return result.length > 0
    },
    rowClassCondition (dataRow) {
      return dataRow.flg_status !== undefined && dataRow.flg_status !== 'N' ? 'input-highlight' : ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// detail2.vue?0856c055